import { Box, withStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';
import { alert } from 'globals/colors';

export const SmsCodeWrapperBox = withStyles(
  ({ palette, spacing, breakpoints }) => ({
    root: {
      ...centerBoxProps,
      background: palette.grey[100],
      margin: spacing(0),
      padding: spacing(4, 0),
      borderRadius: spacing(2.4),
      [breakpoints.up('md')]: {
        margin: spacing(0, -4),
        padding: spacing(6, 8),
      },
    },
  })
)(Box);

export const LinksWrapperBox = withStyles(({ spacing }) => ({
  root: {
    margin: spacing(3, 0),
  },
}))(Box);

export const ErrorLabel = withStyles(({ palette, spacing }) => ({
  root: {
    color: alert.ERROR,
    marginBottom: spacing(1),
  },
}))(FsBody);
